import { render, staticRenderFns } from "./detailUploadFile.vue?vue&type=template&id=7736244f&scoped=true"
import script from "./detailUploadFile.vue?vue&type=script&lang=js"
export * from "./detailUploadFile.vue?vue&type=script&lang=js"
import style0 from "./detailUploadFile.vue?vue&type=style&index=0&id=7736244f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7736244f",
  null
  
)

export default component.exports